import styled from "styled-components";

export const VersionPanel = styled.div`
  width: 350px;
  height: 585px;
  max-height: 585px;
  border-radius: 5px;
  border: 1px solid var(--primary-dark-200);
  background: #e4e6fc;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  align-self: stretch;
  overflow-y: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const VersionCardWrapper = styled.div`
  width: 100%;
`;

export const EmptyCard = styled.div`
  background-color: ${({ selected }) => (selected ? "#FFF" : "transparent")};
  border-radius: 5px;
  min-height: 60px;
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
`;

export const VersionCard = styled.div`
  min-height: 80px;
  display: flex;
  padding: 10px 20px 20px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 11px;
  align-self: stretch;
  background-color: ${({ selected }) => (selected ? "#ffffff" : "transparent")};
  border-radius: 5px;

  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--neutral-gray);
  }
`;

export const VersionCardSeparator = styled.hr`
  border-top: 1px solid var(--primary-dark-200);
  width: 100%;
  margin: 0;
`;

export const VersionMeta = styled.p`
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--primary-blue-300);
  margin-bottom: 6px;

  > span {
    color: var(--primary-dark-600);
    font-family: Rubik;
    font-style: normal;
    font-weight: 500;
    font-size: var(--fs-base);
    line-height: var(--lh-base);
  }
`;

export const VersionChanges = styled.p`
  font-weight: bold;
  color: var(--primary-dark-600);
  font-family: Rubik;
  font-size: var(--fs-lg);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  margin-left: 0;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem;
  width: 100%;
`;
